module.exports = __webpack_public_path__ + "img/characters240Off.52f40c30.svg";